var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('button',{staticClass:"corner-button",class:_vm.colorClass,on:{"click":_vm.handleClick}},[_c('v-icon',{attrs:{"size":"xsmall","name":_vm.iconName}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }